import { render, staticRenderFns } from "./AddRelatedVehicle.vue?vue&type=template&id=401fd134&"
import script from "./AddRelatedVehicle.vue?vue&type=script&lang=ts&"
export * from "./AddRelatedVehicle.vue?vue&type=script&lang=ts&"
import style0 from "./AddRelatedVehicle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAutocomplete,VBtn})
